import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Navigation, Pagination } from 'swiper';
import { Swiper as SwiperContainer, SwiperSlide } from 'swiper/react';
import { SET_ANSWERS, store } from '../state/state';
import Choice from './Choice';
import QuestionHeader from './QuestionHeader';
const answerIsArray = (answer) => Array.isArray(answer);
const Question = ({ question, questionNumber }) => {
    const globalState = useContext(store);
    const { state, dispatch } = globalState;
    const { title, multiple, choices } = question;
    const handleChange = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.value;
        const currentAnswer = state.answers[name];
        const setAnswer = (answer) => {
            dispatch({
                type: SET_ANSWERS,
                answers: {
                    ...state.answers,
                    [name]: answer,
                }
            });
        };
        if (multiple) {
            if (target.checked) {
                if (currentAnswer === undefined) {
                    setAnswer([value]);
                }
                else if (answerIsArray(currentAnswer)) {
                    setAnswer([...currentAnswer, value]);
                }
            }
            else {
                if (currentAnswer !== undefined && answerIsArray(currentAnswer)) {
                    setAnswer(currentAnswer.filter((item) => item !== value));
                }
            }
        }
        else {
            setAnswer(value);
        }
    };
    const checked = (id) => {
        if (state.answers[`q${questionNumber.toString()}`]) {
            const answers = state.answers[`q${questionNumber.toString()}`];
            if (multiple) {
                if (!state.answers.hasOwnProperty(`q${questionNumber.toString()}`)) {
                    return false;
                }
                return Array.isArray(answers) ? answers.includes(id) : false;
            }
            else {
                return answers === id;
            }
        }
        return false;
    };
    return (_jsx("div", { className: "overflow-hidden", children: _jsx("div", { className: "corridor carousel", children: _jsxs(SwiperContainer, { className: "space-y-8", modules: [Navigation, Pagination], slidesPerView: 1.25, spaceBetween: 16, slideToClickedSlide: false, shortSwipes: false, watchOverflow: true, watchSlidesProgress: true, breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 16
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 16
                    },
                    1366: {
                        slidesPerView: 3,
                        spaceBetween: 24
                    },
                    1600: {
                        slidesPerView: 3,
                        spaceBetween: 24
                    }
                }, nested: true, threshold: 4, children: [_jsx("span", { slot: "container-start", children: _jsx(QuestionHeader, { title: title, questionNumber: questionNumber.toString(), choices: choices.length }) }), choices.map((choice) => (_jsx(SwiperSlide, { children: _jsx(Choice, { choice: choice, name: `q${questionNumber.toString()}`, checked: checked(choice.id.toString()), type: multiple ? 'checkbox' : 'radio', handleChange: handleChange }) }, choice.id)))] }) }) }));
};
export default Question;
